import { Product, ProductApi, ProductSlug } from "@/api/product-api";
import { isServer } from "@/libs/isServer";

// 서버 사이드에서만 동적으로 import
const getServerApi = async () => {
  if (isServer) {
    return await import("@/api/product-api.server");
  }
  return null;
};

export const fetchProductBySlugWithCache = async (
  slug: string | null,
  countryCode: "US" | "KR" = "US",
): Promise<Product | null> => {
  if (!slug) {
    return null;
  }

  if (isServer) {
    const serverApi = await getServerApi();
    return serverApi!.findProductBySlug(slug as ProductSlug, countryCode);
  }

  return ProductApi.findProductBySlug(slug as ProductSlug, countryCode);
};

export const fetchAllProductsWithCache = async (
  countryCode: "US" | "KR" = "US",
): Promise<Product[]> => {
  if (isServer) {
    const serverApi = await getServerApi();
    return serverApi!.findAllProducts(countryCode);
  }

  return ProductApi.findAll(countryCode);
};
